export default __webpack_public_path__ + "static/media/calendar.bedebc4f.svg";